import React, { useState } from "react";
import { Modal } from "react-bootstrap";

export default function OrgDetailsDialog(props) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleRadioChange = (option) => {
    setSelectedOption(option);
    setErrorMessage("");
  };

  const handleRegister = () => { 
    if (
      props.organizations &&
      props.organizations.length > 0 &&
      !selectedOption
    ) {
      setErrorMessage("Please select an organization to proceed");
      return;
    }
    
    const orgIdToUse = selectedOption === "create_new" ? null : selectedOption;
    
    props.onConfirmOrg(orgIdToUse);
  };

  const isOrgCodeMatch = props.data?.orgCode && props.organizations?.length === 1;
  const hasMultipleOptions = !props.data?.orgCode && props.organizations?.length > 0;

  return (
    <Modal
      show={props.show}
      onHide={props.onClose}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="org-modal-content"
      style={{ "--bs-modal-width": "700px" }}
    >
      <Modal.Header>
        <Modal.Title>Confirm Organization Details</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="p-3"
        style={{ maxHeight: "60vh", overflowY: "auto" }}
      >
        {errorMessage && (
          <p className="text-danger text-center mb-3">{errorMessage}</p>
        )}
        
        {isOrgCodeMatch && (
          <>
            <p className="text-center mb-4">
              Please confirm the organization details below:
            </p>

            {props.organizations.map((org) => (
              <div
                className="d-flex align-items-start m-3 p-3 border rounded"
                key={org.orgcode}
                style={{
                  cursor: "pointer",
                  backgroundColor:
                    selectedOption === org.orgcode ? "#f0f8ff" : "transparent",
                }}
                onClick={() => handleRadioChange(org.orgcode)}
              >
                <input
                  type="radio"
                  name="organization"
                  value={org.orgcode}
                  checked={selectedOption === org.orgcode}
                  onChange={() => handleRadioChange(org.orgcode)}
                  style={{ marginTop: "4px", cursor: "pointer" }}
                />
                <div className="ps-3 flex-grow-1">
                  <p className="mb-2">
                    <strong>Organization:</strong> {org.name}
                  </p>
                  <p className="mb-2">
                    <strong>Address:</strong> {org.address}, {org.city}, {org.state}
                  </p>
                  <p className="mb-0">
                    <strong>Zip:</strong> {org.zip}
                  </p>
                </div>
              </div>
            ))}
          </>
        )}
        
        {hasMultipleOptions && (
          <>
            <p className="text-center mb-4">
              {props.organizations.length === 1 ? (
                <>
                  An organization with the name "{props.data.orgName}" is
                  already registered with the system. Please select an option
                  below:
                </>
              ) : (
                <>
                  Multiple organizations with similar name "{props.data.orgName}"
                  are already registered. Please select an organization below:
                </>
              )}
            </p>

            {props.organizations.map((org) => (
              <div
                className="d-flex align-items-start m-3 p-3 border rounded"
                key={org.orgcode}
                style={{
                  cursor: "pointer",
                  backgroundColor:
                    selectedOption === org.orgcode ? "#f0f8ff" : "transparent",
                }}
                onClick={() => handleRadioChange(org.orgcode)}
              >
                <input
                  type="radio"
                  name="organization"
                  value={org.orgcode}
                  checked={selectedOption === org.orgcode}
                  onChange={() => handleRadioChange(org.orgcode)}
                  style={{ marginTop: "4px", cursor: "pointer" }}
                />
                <div className="ps-3 flex-grow-1">
                  <p className="mb-2">
                    <strong>Organization:</strong> {org.name}
                  </p>
                  <p className="mb-2">
                    <strong>Address:</strong> {org.address}, {org.city}, {org.state}
                  </p>
                  <p className="mb-0">
                    <strong>Zip:</strong> {org.zip}
                  </p>
                </div>
              </div>
            ))}

            <div
              className="m-3 p-3 border rounded"
              style={{
                cursor: "pointer",
                backgroundColor:
                  selectedOption === "create_new" ? "#f0f8ff" : "transparent",
              }}
              onClick={() => handleRadioChange("create_new")}
            >
              <div className="d-flex align-items-start">
                <input
                  type="radio"
                  name="organization"
                  value="create_new"
                  checked={selectedOption === "create_new"}
                  onChange={() => handleRadioChange("create_new")}
                  style={{ marginTop: "4px", cursor: "pointer" }}
                />
                <div className="ps-3">
                  <p className="mb-0">
                    <strong>None of the above - Create new organization</strong>
                  </p>
                  <small className="text-muted">
                    If the organization listed above doesn't belong to you,
                    select this option to create a new organization using the
                    details you entered.
                  </small>
                </div>
              </div>
            </div>

            <p className="m-3 text-center text-muted small">
              If you find this difficult or confusing, please contact us at{" "}
              <a href="mailto:support@cibermed.com">support@cibermed.com</a>
            </p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="flex-column border-top p-3">
        <div className="d-flex flex-column flex-md-row justify-content-between w-100">
          <button
            onClick={handleRegister}
            className="btn register-btn m-0 mb-3 mb-md-0 me-md-2 flex-fill"
          >
            Confirm
          </button>
          <button 
            onClick={props.onClose} 
            className="btn back-btn m-0 ms-md-2 flex-fill"
          >
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}